import React, { useState, createContext, useContext, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken') || null);
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || '');
  const [isAuthenticated, setIsAuthenticated] = useState(!!authToken);
  const [isAuthResolved, setIsAuthResolved] = useState(false);

  // Función para iniciar sesión
  const login = (token, role) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('userRole', role);
    setAuthToken(token);
    setUserRole(role);
    setIsAuthenticated(true); // Mover aquí
    console.log("AuthContext.js token: ", token);
  };

  // Función para cerrar sesión
  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    setAuthToken(null);
    setUserRole(''); // Mover aquí
    setIsAuthenticated(false); // Mover aquí
  };

  // Verificar token en el arranque y cuando cambie
  useEffect(() => {
    const validateSession = async () => {
      if (!authToken) {
        setIsAuthenticated(false);
        setIsAuthResolved(true);
        return;
      }

      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/user`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${authToken}`
          }
        });

        if (response.ok) {
          setIsAuthenticated(true);
        } else {
          console.error('Validación de sesión fallida. Redirigiendo a login.');
          logout();
        }
      } catch (error) {
        console.error('Error validando la sesión:', error);
        logout();
      } finally {
        setIsAuthResolved(true);
      }
    };

    validateSession();
  }, [authToken]);

  return (
    <AuthContext.Provider value={{ authToken, isAuthenticated, isAuthResolved, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
